import React from 'react';
import { motion } from 'framer-motion';

const EventCalendar = ({ events }) => {
  // Agrupar eventos por mês
  const groupByMonth = () => {
    const groups = {};
    events.forEach((event) => {
      // Extrair mês da data (formato: "15/06/2025 - 19h")
      const dateMatch = event.date.match(/\d{2}\/(\d{2})\/\d{4}/);
      if (dateMatch) {
        const month = parseInt(dateMatch[1]);
        const monthName = new Date(2025, month - 1).toLocaleDateString('pt-BR', { month: 'long' });
        if (!groups[monthName]) {
          groups[monthName] = [];
        }
        groups[monthName].push(event);
      }
    });
    return groups;
  };

  const monthGroups = groupByMonth();
  const months = Object.keys(monthGroups);

  if (months.length === 0) {
    return (
      <div className="text-center py-12 text-white/50">
        <div className="text-5xl mb-4"></div>
        <p>Nenhum evento agendado</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="text-4xl"></div>
        <div>
          <h3 className="text-2xl font-bold font-['Jost'] text-[#c0c0c0]">Calendário de Eventos</h3>
          <p className="text-white/50 text-sm">Próximas experiências exclusivas</p>
        </div>
      </div>

      {months.map((month, idx) => (
        <motion.div
          key={month}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: idx * 0.1 }}
          className="space-y-4"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#c0c0c0]/30 to-transparent"></div>
            <h4 className="text-xl font-semibold text-[#c0c0c0] uppercase">{month}</h4>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#c0c0c0]/30 to-transparent"></div>
          </div>

          <div className="grid gap-4">
            {monthGroups[month].map((event, eventIdx) => {
              const dateMatch = event.date.match(/(\d{2})\/(\d{2})\/\d{4}\s*-\s*(.+)/);
              const day = dateMatch ? dateMatch[1] : '';
              const time = dateMatch ? dateMatch[3] : event.date;

              return (
                <motion.div
                  key={event.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 + eventIdx * 0.05 }}
                  className="bg-[#141418] border border-white/10 rounded-xl p-4 hover:border-[#c0c0c0]/50 transition flex gap-4"
                >
                  {/* Date Box */}
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#c0c0c0] to-[#e8e8e8] rounded-lg flex flex-col items-center justify-center text-black">
                    <div className="text-2xl font-bold leading-none">{day}</div>
                    <div className="text-[10px] uppercase font-semibold">{month.substring(0, 3)}</div>
                  </div>

                  {/* Event Info */}
                  <div className="flex-1">
                    <h5 className="font-bold text-lg mb-1">{event.title}</h5>
                    <p className="text-sm text-white/70 mb-2 line-clamp-2">{event.description}</p>
                    <div className="flex flex-wrap gap-3 text-xs text-white/50">
                      <span className="flex items-center gap-1">
                        <span>🕐</span>
                        {time}
                      </span>
                      <span className="flex items-center gap-1">
                        <span></span>
                        {event.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <span></span>
                        {event.attendees?.length || 0}/{event.max_attendees}
                      </span>
                      <span className="flex items-center gap-1 text-[#c0c0c0]">
                        <span></span>
                        R$ {event.price}
                      </span>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default EventCalendar;